import { Input } from 'antd'
import CIMSFormItem from 'components/CIMSFormItem'
import { HelpMessage } from 'utils/constants'
import UserSelect from 'components/CIMSSelect/common/UserSelect'
import { LabeledValueType } from 'components/CIMSSelect/types'

export const EditResponseDisciplineModalBody: React.FC = () => {
  return (
    <>
      <CIMSFormItem
        name="name"
        label="Name"
        help={HelpMessage.RequestsForInformation.ResponseDisciplines.Name}
        requiredMessage="Please enter a name"
      >
        <Input />
      </CIMSFormItem>
      <CIMSFormItem
        name="description"
        label="Description"
        help={HelpMessage.Description('Response Discipline')}
      >
        <Input />
      </CIMSFormItem>
      <CIMSFormItem
        name="responders"
        label="Responders"
        help={HelpMessage.RequestsForInformation.ResponseDisciplines.Responders}
      >
        <UserSelect mode="multiple" />
      </CIMSFormItem>
    </>
  )
}

export type EditResponseDisciplineModalValues = {
  name: string
  description?: string | null
  responders?: LabeledValueType[]
}
